import React, { useEffect, useRef } from "react";

const AddressAutocomplete = ({ onSelect }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["address"],
        componentRestrictions: { country: "us" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place && place.address_components) {
        const addressData = {
          formatted: place.formatted_address,
          lat: place.geometry?.location.lat(),
          lng: place.geometry?.location.lng(),
          components: place.address_components,
        };
        onSelect(addressData);
      }
    });
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      placeholder="Enter your business address"
      className="address-input"
    />
  );
};

export default AddressAutocomplete;
